import Styles from './TariffElementsComponent.module.css'
import Colors from 'Theme/Colors'
import { IFText, PriceComponentContainer } from 'Components'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { DoNotDisturbOn } from '@mui/icons-material'

const StyledDiv = styled.div`
  &:hover {
    color: whitesmoke;
  }
`
const normalizeElement = (element) => ({
  id: crypto?.randomUUID?.() ?? String(Date.now() + Math.random()),
  priceComponents: Array.isArray(element?.priceComponents)
    ? element.priceComponents
    : [],
  restrictions: element?.restrictions ?? null,
})

const makeEmptyElement = () => ({
  id: crypto?.randomUUID?.() ?? String(Date.now() + Math.random()),
  priceComponents: [{ type: '', price: '', vat: '', stepSize: '' }],
  restrictions: null,
})

const TariffElementsComponent = ({
  elements = [],
  onChange,
  onErrorChange,
  operator,
}) => {
  const { t } = useTranslation()
  const addBtnRef = useRef(null)
  const buttonRef = useRef()
  const RemoveButtonRef = useRef()

  const [items, setItems] = useState([makeEmptyElement()])
  const [priceComponentError, setPriceComponentError] = useState(false)

  useEffect(() => {
    onErrorChange?.(priceComponentError)
  }, [priceComponentError, onErrorChange])
  useEffect(() => {
    if (Array.isArray(elements) && elements.length > 0) {
      setItems(elements.map(normalizeElement))
    } else {
      setItems([makeEmptyElement()])
    }
  }, [])

  useEffect(() => {
    if (!onChange) return
    onChange(
      items.map(({ priceComponents, restrictions }) => ({
        priceComponents,
        ...(restrictions &&
        typeof restrictions === 'object' &&
        !Array.isArray(restrictions) &&
        Object.keys(restrictions).length > 0
          ? { restrictions }
          : {}),
      })),
    )
  }, [items])

  const addComponent = () => {
    setItems((prev) => [...prev, makeEmptyElement()])
    addBtnRef.current?.focus()
  }

  const removeComponent = (id) => {
    setItems((prev) =>
      prev.length > 1 ? prev.filter((x) => x.id !== id) : prev,
    )
  }

  const handleItemChange = (idx, { priceComponents, restrictions }) => {
    setItems((prev) => {
      const next = [...prev]
      next[idx] = { ...next[idx], priceComponents, restrictions }
      return next
    })
  }
  return (
    <div className={Styles.Container}>
      <div className={Styles.ContentContainer}>
        {items.map((item, index) => (
          <div key={item.id} className={Styles.InputItem}>
            <div className={Styles.TitleContainer}>
              {items.length > 1 && (
                <DoNotDisturbOn
                  className={Styles.RemoveIcon}
                  style={{ color: Colors.ChargePointTariffListItem.RemoveIcon }}
                  onClick={() => removeComponent(item.id)}
                  aria-label={t('TariffModal.RemoveElement')}
                  role="button"
                />
              )}
              <IFText
                className={Styles.TitleText}
                style={{ color: Colors.text }}
              >
                {t('TariffModal.Elements')}
              </IFText>
            </div>

            <PriceComponentContainer
              index={index}
              restrictions={item.restrictions}
              priceComponents={item.priceComponents}
              onChange={(payload) => handleItemChange(index, payload)}
              onErrorChange={(error) => {
                setPriceComponentError(error)
              }}
              operator={operator}
            />
          </div>
        ))}
      </div>

      <div className={Styles.AddButtonDiv}>
        <button
          type="button"
          className={Styles.AddButton}
          style={{ color: Colors.primary }}
          onClick={addComponent}
          ref={buttonRef}
        >
          <StyledDiv
            className={Styles.IconContainer}
            style={{ color: Colors.primary }}
          >
            <IFText className={Styles.AddButtonText}>
              {t('TariffModal.AddElement')}
            </IFText>
          </StyledDiv>
        </button>
      </div>
    </div>
  )
}

TariffElementsComponent.propTypes = {
  elements: PropTypes.object,
  onChange: PropTypes.func,
}

export default TariffElementsComponent
